// extracted by mini-css-extract-plugin
export default {"table_root":"tableStructure_table_root__eI1f+","table_wrap":"tableStructure_table_wrap__9aObu"};